import api from "../../api";
import utils from "../../utils";
import regex from "../../regex";
import Lottie from "react-lottie-player";
import values from "../../values";
import anLogin from "../../../assets/animations/an-Login.json";
import OtpInput from "react-otp-input";
import dictionary from "../../dictionary";
import errorHandler from "../../utils/errorHandler";

import React, { useEffect } from "react";

import { IItem } from "../../types/common.interface";
import { Col, Container, Row } from "react-bootstrap";
import {
  CustomButton2,
  CustomInput,
  CustomRadioButtonGroup,
  CustomTimer,
} from "../../components";

import "./index.scss";
import Column from "../../components/CustomView/Column";
import { useTranslation } from "react-i18next";
interface iData {
  phoneNumber: string;
  otp: string;
}

const {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} = require("react-simple-captcha");

const LoginScreen = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [canResend, setCanResend] = React.useState<boolean>(false);
  const [isOtpSend, setIsOtpSend] = React.useState<boolean>(false);
  const [captchaValue, setCaptchaValue] = React.useState<string>("");
  const [captchaError, setCaptchaError] = React.useState<string>("");
  const [resendTime, setResendTime] = React.useState({
    initialMinute: 2,
    initialSeconds: 0,
  });
  const [selectedRole, setSelectedRole] = React.useState<IItem | null>(
    values.topMenuItems.LOGIN_ROLE_ITEM[0]
  );
  const [data, setData] = React.useState<iData>({
    phoneNumber: "",
    otp: "",
  });

  const { t } = useTranslation();

  // ============================================== Use queries =======================================

  const sendVerificationCode = async () => {
    const resSendCode = await api.post.common.sendVerificationSms({
      phoneNumber: data.phoneNumber,
      userType: selectedRole?.value,
    });
    return resSendCode;
  };

  const login = async () => {
    const resLogin = await api.post.common.verifyCode({
      phoneNumber: utils.convertNumbers2English(data.phoneNumber),
      verificationCode: utils.convertNumbers2English(data.otp),
      userType: selectedRole?.value,
    });
    return resLogin;
  };

  const checkUserAdmin = async () => {
    var phoneNumber = data.phoneNumber;
    if (data.phoneNumber.charAt(0) === "0") {
      phoneNumber = data.phoneNumber.substring(1);
    }
    const isUserAdmin = await api.get.common.userAndTypeExist({
      phoneNumber: phoneNumber,
      userType: selectedRole?.value,
    });
    return isUserAdmin?.result?.isUserTypeExist;
  };

  const resendCode = async () => {
    setResendTime({ initialMinute: 2, initialSeconds: 0 });
    if (canResend) {
      setIsLoading(true);
      setCanResend(false);
      setIsOtpSend(false);
      if (await sendVerificationCode()) setIsOtpSend(true);
      setIsLoading(false);
    }
  };

  // ============================================== functions =======================================

  const onRoleChange = (item: IItem | null) => {
    setSelectedRole(item);
  };

  const onSubmit = async () => {
    if (isOtpSend) {
      setIsLoading(true);
      const resLogin: any = await login();

      if (resLogin === "error") {
        utils.errorHandler(5014);
        setIsLoading(false);
      }
      const {
        token,
        userType,
        userId,
        fullName,
        avatar,
        balance,
        city,
        province,
      } = resLogin;
      if (token) {
        utils.setLoginData({
          ...resLogin,
        });
        if (selectedRole)
          window.location.href = `${dictionary.roleToUrl(
            String(selectedRole?.value)
          )}`;
      }
    } else {
      if (validateCaptcha(captchaValue)) {
        setCaptchaError("");
        if (!regex.phoneNumber(data.phoneNumber)) return errorHandler(9010);
        setIsLoading(true);
        if (!(await checkUserAdmin())) {
          setIsLoading(false);
          return errorHandler(9003);
        }
        if (await sendVerificationCode()) setIsOtpSend(true);
        else errorHandler(9014);
        setIsLoading(false);
      } else {
        setCaptchaError("عبارت امنیتی اشتباه است");
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  useEffect(() => {
    loadCaptchaEnginge(4, "lightgray", "black", "numbers"); // loadCaptchaEnginge(Number_Of_Captcha_Charcters, Background_Color, Font_Color, Special_Characters);
  }, []);

  return (
    <section id="login-screen-container">
      <Container fluid>
        <Row>
          <Col lg={6}>
            <div className="left-side">
              <div className="login-card">
                <h1>{t("panel")}</h1>
                <div
                  // className='role-holder'
                  style={{
                    pointerEvents: isOtpSend || isLoading ? "none" : "all",
                  }}
                >
                  <CustomRadioButtonGroup
                    menus={values.topMenuItems.LOGIN_ROLE_ITEM.map((item) => {
                      return { ...item, name: t(item?.name as string) };
                    })}
                    selected={selectedRole}
                    onClick={onRoleChange}
                    canNull={false}
                  />
                </div>
                <div className="phone-number-holder">
                  <div className="enter-number-container">
                    <CustomInput
                      isDisable={isOtpSend ? isOtpSend : false || isLoading}
                      maxLength={13}
                      value={utils.hyphenfyMobileNumber(data.phoneNumber)}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setData({
                          ...data,
                          // Persian/Arabic digits from a Persian keyboard failed the 09XXXXXXXXX check; keep ASCII digits only
                          phoneNumber: utils
                            .convertNumbers2English(event.target.value)
                            .replace(/[^0-9]/g, ""),
                        });
                      }}
                      label="شماره‌ی موبایل"
                      placeHolder="09XX - XXX - XXXX"
                      textAlign="center"
                      leftIcon="fas fa-mobile"
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  {!isOtpSend && (
                    <Row className="captcha dropdown">
                      <Column medium={6}>
                        <div className="input-block">
                          <CustomInput
                            type="text"
                            id="captcha"
                            name="captcha"
                            value={captchaValue}
                            placeHolder={"عبارت امنیتی را وارد نمایید"}
                            onValueChange={(event) =>
                              setCaptchaValue(event.target.value)
                            }
                            onKeyDown={handleKeyDown}
                            // error={errors.captcha && touched.captcha}
                            // errorText={errors.captcha}
                            // autoComplete="off"
                          />
                          {/* <div className="error-div">{errors.captcha}</div> */}
                          {/* <input /> */}
                          {/* {errors.captcha && touched.captcha ? (
                                <p className="form-error">{errors.captcha}</p>
                              ) : null} */}
                        </div>
                      </Column>
                      <Column medium={5} className="reload-captcha-column">
                        <LoadCanvasTemplate reloadText={`بارگذاری مجدد`} />
                      </Column>
                      <div className="error">{captchaError}</div>

                      {/* <div className="">{captchaError}</div> */}
                    </Row>
                  )}

                  {isOtpSend && (
                    <div className="edit-number-wrapper">
                      <h4 className="edit-number-sub"> {" شماره‌ همراه "} </h4>
                      <h4
                        className="edit-number-text"
                        onClick={() => setIsOtpSend(!isOtpSend)}
                      >
                        تغییر
                      </h4>
                    </div>
                  )}
                </div>
                {isOtpSend && (
                  <div onKeyDown={handleKeyDown} className="mv opt-input">
                    <OtpInput
                      value={data.otp}
                      isInputNum
                      onChange={(event: string) =>
                        setData({ ...data, otp: event })
                      }
                      numInputs={5}
                      containerStyle={{
                        direction: "ltr",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      inputStyle={{
                        border: "none",
                        textAlign: "center",
                        width: "2.125rem",
                        backgroundColor: "#e1f5fe",
                        borderRadius: "0.313rem",
                        padding: "0.212rem",
                      }}
                    />

                    <div className="resend-code-holder">
                      {!canResend && (
                        <CustomTimer
                          time={resendTime}
                          onEnd={() => setCanResend(!canResend)}
                        />
                      )}
                      <h4 className="resend-code-text" onClick={resendCode}>
                        {canResend ? "کد را دوباره ارسال کنید" : "اعتبار کد"}
                      </h4>
                    </div>
                  </div>
                )}
                <CustomButton2
                  isLoading={isLoading}
                  onClick={onSubmit}
                  title={isOtpSend ? "ورود" : "ارسال کد"}
                  type="primary"
                />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="right-side">
              <Lottie
                loop
                animationData={anLogin}
                play
                style={{ width: "100%", height: "90%" }}
              />
              {/* <div className="animation-subtitle">
                <div className="login-text">
                  <p>{"constants.LOGIN_SUBTITLE"}</p>
                  <p>{"constants.LOGIN_DESCRIPTION"}</p>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LoginScreen;
